enum NeuronReportView {
  VenueType = 'Venue Type',
}

export default NeuronReportView;
